import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "home-echarts-header",
  style: {"padding":"10px 24px 0 24px","height":"auto"}
}
const _hoisted_2 = { class: "home-echarts-header__title" }

import type { PropType, Ref } from 'vue'
import { onMounted, ref, watch } from 'vue'
import { useECharts } from '@/hooks/useECharts'
import dayjs, { Dayjs } from 'dayjs'
import { getTargetCompletionListByEmployeeNo } from '@/api/gucangSales/regionDataBoard'


const __default__ = {
  name: 'SellerMonthlyTargetCompletion'
}

interface ItemCommonType {
  day_value?: number,
  targetValueTotal?: number, // 月度业绩目标值
  completionValueTotal?: number, // 月度业绩实际完成值
  targetCompletionRate?: string, // 仅显示
  targetCompletionRateNum?: number, // 供图表数据
  employeeNo?: string, // 员工工号
  employeeName?: string, // 员工名称
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  title: {
    type: String as PropType<string>,
    default: '业务员业绩目标完成情况'
  },
  formState: {
    type: Object as PropType<Object>
  },
  width: {
    type: String as PropType<string>,
    default: '100%'
  },
  height: {
    type: String as PropType<string>,
    default: '350px'
  },
  marginBottom: {
    type: String as PropType<string>,
    default: '8px'
  },
  allowClear: {
    type: Boolean as PropType<boolean>,
    default: false
  }
},
  setup(__props) {

const yearValue = ref<Dayjs>(dayjs())
const props = __props

const spinning = ref(false)
const showECharts = ref(false)
const xAxisData = ref<any[]>([])
onMounted(() => {
  handleQueryChange()
})
watch(() => props.formState, (val) => {
  handleQueryChange()
})
const handleQueryChange = () => {
  xAxisData.value = generateEmployeeArray()
  getData()
}
const generateEmployeeArray = () => {
  const datas: any[] = []
  props.formState?.region?.deptScopeInfo.forEach((employee: any) => {
    if (employee) {
      datas.push(employee)
    }
  })
  return datas
}
const getData = () => {
  spinning.value = true
  getTargetCompletionListByEmployeeNo(props.formState).then((res) => {
    const targetCompletionList = res.data?.targetCompletionList as unknown as ItemCommonType[]
    const transTargetCompletionList = transChartData(targetCompletionList)
    if (transTargetCompletionList.length) {
      showECharts.value = true
      let maxTarget = 0
      let maxRate = 100
      transTargetCompletionList.forEach(value => {
        if (value) {
          const targetValue = value.targetValueTotal ?? 0
          const completionRate = value.targetCompletionRateNum ?? 0
          const targetCompletion = value.completionValueTotal ?? 0
          if (targetValue > maxTarget) {
            maxTarget = targetValue
          }
          if (targetCompletion > maxTarget) {
            maxTarget = targetCompletion
          }
          if (completionRate > maxRate) {
            maxRate = completionRate
          }
        }
      })
      initChart(transTargetCompletionList, maxTarget, Math.ceil(maxRate))
    } else {
      showECharts.value = false
      initChart([], 0)
    }
  }).finally(() => {
    spinning.value = false
  })
}
/// 格式化接口数据和人员对应
const transChartData = (serviceData: ItemCommonType[]) => {
  const matchData: ItemCommonType[] = []
  if (serviceData && serviceData.length > 0) {
    xAxisData.value.forEach((axis) => {
      const matchItem = serviceData.find((item) => {
        return item.employeeNo === axis.employeeNo
      })
      if (matchItem) {
        matchItem.targetCompletionRateNum = matchItem.targetValueTotal ? Number((((matchItem.completionValueTotal ?? 0) / matchItem.targetValueTotal) * 100).toFixed(2)) : 0
        matchData.push(matchItem)
      } else {
        matchData.push(undefined as unknown as ItemCommonType)
      }
    })
  }
  return matchData
}
const chartRef = ref<HTMLDivElement | null>(null)
const { setOptions } = useECharts(chartRef as Ref<HTMLDivElement>, undefined, true)
const initChart = (transTargetCompletionList: ItemCommonType[], maxTarget: number, maxRate = 100) => {
  setOptions({
    // 悬浮窗
    tooltip: {
      trigger: 'axis',
      backgroundColor: '#1D4CD2',
      textStyle: {
        color: 'White'
      },
      formatter: function (params) {
        const currentData = xAxisData.value[params[0].dataIndex].employeeName
        const toolsTipsResult = []
        toolsTipsResult.push(currentData)
        for (let i = 0; i < params.length; i++) {
          const currentParam = params[i]
          toolsTipsResult.push(currentParam.seriesName + '  <strong>' + (i === 2 ? currentParam.value + '%' : currentParam.value) + '</strong>')
          // toolsTipsResult.push('目标值  <strong>' + currentHoverData?.quantity + '</strong>')
          // toolsTipsResult.push('完成值  <strong>' + currentHoverData?.total + '</strong>')
          // toolsTipsResult.push(`完成率  <strong>${(currentHoverData?.total ? Number((((currentHoverData.quantity ?? 0) / currentHoverData.total) * 100).toFixed(2)) : 0)}%` + '</strong>')
        }
        return toolsTipsResult.join('<br>')
      }
    },
    /// 在这里配置线条颜色和legend颜色一致
    color: ['#BCC7DD', '#1D4CD2', '#FF9A3E'],
    legend: {
      itemWidth: 12,
      itemHeight: 2,
      left: 'right',
      icon: 'react',
      right: '50%',
      data: ['目标值', '完成值', '完成率']
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '3%',
      containLabel: true
    },
    xAxis: {
      type: 'category',
      boundaryGap: false,
      data: xAxisData.value.map((item) => item.employeeName)
    },
    yAxis: [
      {
        type: 'value',
        axisLabel: {
          formatter: '{value} %'
        },
        position: 'right',
        max: maxRate,
        offset: 8,
        splitLine: {
          show: true,
          lineStyle: {
            color: '#D8DFE4',
            type: 'dashed'
          }
        }
      },
      {
        type: 'value',
        position: 'left',
        offset: 8,
        max: maxTarget ? Math.ceil(maxTarget * 1.1) : 50,
        // axisLabel: {
        //   show: false // 设置为false以隐藏Y轴刻度
        // },
        splitLine: {
          show: false
        }
      }
    ],
    series: [
      {
        name: '目标值',
        type: 'bar',
        barWidth: '40%',
        yAxisIndex: 1,
        data: transTargetCompletionList.map(value => value?.targetValueTotal ?? 0)
      },
      {
        name: '完成值',
        barWidth: '20%',
        type: 'bar',
        barGap: '-75%',
        yAxisIndex: 1,
        data: transTargetCompletionList.map(value => value?.completionValueTotal ?? 0)
      },
      {
        name: '完成率',
        type: 'line',
        smooth: true,
        yAxisIndex: 0,
        data: transTargetCompletionList.map(value => value?.targetCompletionRateNum ?? 0)
      }
    ]
  })
}

return (_ctx: any,_cache: any) => {
  const _component_dc_layout_empty = _resolveComponent("dc-layout-empty")!
  const _component_a_spin = _resolveComponent("a-spin")!

  return (_openBlock(), _createElementBlock("div", {
    class: "home-echarts-wrap",
    style: _normalizeStyle({ width: __props.width, height: __props.height, marginBottom: __props.marginBottom })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h3", _hoisted_2, _toDisplayString(__props.title), 1)
    ]),
    _createVNode(_component_a_spin, {
      spinning: spinning.value,
      delay: 200
    }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", {
          ref_key: "chartRef",
          ref: chartRef,
          class: "home-echarts-content"
        }, null, 512), [
          [_vShow, showECharts.value]
        ]),
        (!showECharts.value)
          ? (_openBlock(), _createBlock(_component_dc_layout_empty, {
              key: 0,
              type: "nothing"
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["spinning"])
  ], 4))
}
}

})